/**
 * @class pagingTable.
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import Loader from '../loader';
import Pager from './pager';
import PagingHeader from './pagingHeader';
const PagingTable = ({
  attributeMap,
  indexQuery,
  sortBy: parentSortBy,
  children,
  headers,
  hideSortOptions: _hideSortOptions = false,
  loading,
  hasPrevious,
  hasNext,
  handleNextPage,
  handlePreviousPage
}) => {
  const sortBy = headerName => {
    if (attributeMap[headerName]) {
      parentSortBy(attributeMap[headerName], indexQuery);
    } else {
      // this is expected, in configurable cabinets not all columns will be sortable
      // eslint-disable-next-line no-console
      console.error(`Unrecognized Column Name for sorting: ${headerName}`);
    }
  };
  let rows = children || [];
  if (!rows.length) {
    rows = /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
      className: "t-pt-noresults",
      colSpan: headers.length + 1
    }, "No results"));
  }
  return /*#__PURE__*/React.createElement(Loader, {
    loaded: !loading
  }, /*#__PURE__*/React.createElement("div", {
    className: "t-paging-table-scroll",
    "data-testid": "paging-table-scroll"
  }, /*#__PURE__*/React.createElement(Table, {
    striped: true,
    bordered: true,
    size: "sm",
    hover: true,
    "data-testid": "paging-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, headers.map((name, headerIndex) => /*#__PURE__*/React.createElement(PagingHeader, {
    key: typeof name === 'string' ? name : `header-${headerIndex}`,
    name: name,
    indexQuery: indexQuery,
    hideSortOptions: _hideSortOptions,
    attributeMap: attributeMap,
    sortBy: sortBy
  })))), /*#__PURE__*/React.createElement("tbody", null, rows))), /*#__PURE__*/React.createElement(Pager, {
    hasPrevious: hasPrevious,
    hasNext: hasNext,
    indexQuery: indexQuery,
    loading: loading,
    pagePrevious: handlePreviousPage,
    pageNext: handleNextPage
  }));
};
PagingTable.propTypes = {
  children: PropTypes.node.isRequired,
  handleNextPage: PropTypes.func.isRequired,
  handlePreviousPage: PropTypes.func.isRequired,
  hasNext: PropTypes.bool.isRequired,
  hasPrevious: PropTypes.bool.isRequired,
  headers: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])).isRequired,
  indexQuery: PropTypes.shape({
    filters: PropTypes.shape({}),
    paging: PropTypes.shape({
      current: PropTypes.number.isRequired
    }).isRequired,
    sortAttribute: PropTypes.string,
    sortDirection: PropTypes.string
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  sortBy: PropTypes.func.isRequired,
  /* eslint-disable react/forbid-prop-types */
  attributeMap: PropTypes.object.isRequired,
  /* eslint-enable react/forbid-prop-types */
  hideSortOptions: PropTypes.bool
};
export default PagingTable;